import { EBeaconAction } from '@dicetechnology/dice-unity/lib/services/Beacon/types';
import { ConvivaContentMetadataStreamType } from '@dicetechnology/doris-plugin-conviva';
import type { ConvivaLoadMetadata } from '@dicetechnology/doris-plugin-conviva';
import type { LoadRequestData } from 'chromecast-caf-receiver/cast.framework.messages';

import { DiceReceiverManager } from '../services';

import { isInteger } from './isInteger';
import { throwError } from './throwError';

interface ConvivaMetadata {
    conviva: ConvivaLoadMetadata;
}

export const getConvivaMetadata = async (loadRequestData: LoadRequestData): Promise<ConvivaMetadata | undefined> => {
    const {
        media: { contentId, metadata }
    } = loadRequestData;

    const diceReceiverManager = DiceReceiverManager.getInstance();
    const { convivaCustomerKey, showContentTitles } = diceReceiverManager.getSettings() ?? throwError('Invalid state!');

    if (!convivaCustomerKey) {
        return;
    }

    const { userId: viewerId = 'NA' } = await diceReceiverManager.getUserDetails();
    const { title: assetName = 'NA' } = metadata as Partial<MediaMetadata>;
    const beacon = diceReceiverManager.getBeacon();
    const streamType =
        beacon?.getAction() === EBeaconAction.LIVE ? ConvivaContentMetadataStreamType.LIVE : ConvivaContentMetadataStreamType.VOD;

    let videoId: string | undefined;
    if (isInteger(contentId)) {
        videoId = contentId;
    } else {
        const beaconVideoId = beacon?.getVideoId();
        if (isInteger(beaconVideoId)) {
            videoId = beaconVideoId;
        }
    }

    return {
        conviva: {
            contentMetadata: {
                viewerId,
                applicationName: 'Chromecast',
                playerName: 'Chromecast',
                streamType,
                assetName: showContentTitles ? assetName : 'NA',
                custom: {
                    ['c3.cm.id']: contentId
                }
            }
        }
    };
};
